<a routerLink="/client/add" class="btn btn-secondary btn-block">
  <i class="fa fa-plus"></i> New
</a>